import React from "react";
import "../../../Assets/CSS/bulkorder.css";
import "../../OMS/oms.css";

import BuyerDetailsForm from "../forms/buyer/buyerDetails";
import PoBosBuyerForm from "../forms/buyer/poBosBuyer";
import ProductDetailsBuyerForm from "../forms/buyer/productDetailsBuyer";
import UnloadingDetailsBuyerForm from "../forms/buyer/unloadingDetailsBuyer";
import UnloadingQualityParameters from "../forms/buyer/unloadingQualityParameters";
import TransportDetailBuyerForm from "../forms/buyer/transportDetailsBuyer";
import RejectionDetailsBuyerForm from "../forms/buyer/rejectionDetailsBuyer";
import PaymentDetailsBuyerForm from "../forms/buyer/paymentDetailsBuyer";
import DeductionDetails from "../forms/buyer/deductionDetails";
import GoodsReceiptNote from "../forms/buyer/goodsReceiptNote";
import OrderBrokerage from "../forms/orderBrokerage";

function BuyerSide({ omsData, getOMSData, id }) {
  return (
    <>
      {
        <div className=" ms-0 ps-0 ">
          <div className=" gap-2 mt-2">
            <BuyerDetailsForm omsData={omsData} />
            <PoBosBuyerForm
              orderId={id}
              poBosUploads={omsData?.operations_po_bos_uploads}
              getOMSData={getOMSData}
              omsData={omsData}
            />
            <ProductDetailsBuyerForm
              omsData={omsData}
              getOMSData={getOMSData}
            />
            <UnloadingDetailsBuyerForm
              orderId={id}
              omsData={omsData}
              getOMSData={getOMSData}
            />
            <UnloadingQualityParameters
              orderId={id}
              omsData={omsData}
              getOMSData={getOMSData}
            />
            <DeductionDetails
              orderId={id}
              getOMSData={getOMSData}
              omsData={omsData}
            />
            <TransportDetailBuyerForm
              orderId={id}
              orderShipmentDocs={omsData?.order_shipment_docs}
              getOMSData={getOMSData}
              omsData={omsData}
            />
            <GoodsReceiptNote
              omsData={omsData}
              getOMSData={getOMSData}
              orderId={id}
            />
            <RejectionDetailsBuyerForm
              omsData={omsData}
              getOMSData={getOMSData}
              orderId={id}
            />
            <PaymentDetailsBuyerForm
              paymentData={omsData?.only_bnps}
              omsData={omsData}
              getOMSData={getOMSData}
              orderId={id}
            />
            <OrderBrokerage
              omsData={omsData}
              orderId={id}
              merchantType="buyer"
              getOMSData={getOMSData}
            />
          </div>
        </div>
      }
    </>
  );
}

export default BuyerSide;
